import { CONSTS } from '../config/objectConst'

const KEY = 'contactsPageSize'

export const contactsPageSize = {
	get() {
		const saved = localStorage.getItem(KEY) ?? CONSTS.PAGE_SIZE.toString()
		const result = Number.parseInt(saved, 10)

		return Number.isNaN(result) ? CONSTS.PAGE_SIZE : result
	},

	save(value: number) {
		localStorage.setItem(KEY, String(value))
	}
}
